import { joinParts } from './utils'

export const venue = {
  components: (id: string) => joinParts('venue', id),
}
